import type { OneCPayment } from "../types";
import { formatDate, formatNumber } from "./Ui";

export function paymentCurrency(code: string) {
  return ({ "417": "сом", "840": "USD", "643": "RUB", "978": "EUR" } as Record<string, string>)[code] || code;
}
export function PaymentStatus({ payment }: { payment?: OneCPayment | null }) {
  if (!payment) return <span className="muted">Нет данных 1С</span>;
  const tone = payment.error || payment.remaining > 0 ? "picking" : "issued";
  return <><span className={`status status--${tone}`}>{payment.status}</span>{payment.error && <small>{payment.error}</small>}</>;
}
export function PaymentAmount({ payment, field }: { payment?: OneCPayment | null; field: "paidAmount" | "remaining" | "receivableDebt" }) {
  return payment && payment[field] != null ? <>{formatNumber(payment[field]!)} {paymentCurrency(payment.currency)}</> : <>—</>;
}
export function DebtStatus({ payment }: { payment?: OneCPayment | null }) {
  if (!payment) return <span className="muted">Нет данных 1С</span>;
  if (payment.error || payment.receivableError) return <span className="status status--picking">Нужна сверка долга</span>;
  if (payment.receivableDebt == null) return <span className="muted">Долг ещё не получен из 1С</span>;
  return <span className={`status status--${payment.receivableDebt > 0 ? "picking" : "issued"}`}>{payment.receivableDebt > 0 ? "Есть долг" : "Долга нет"}</span>;
}


export function ReturnDetails({ payment, compact = false }: { payment?: OneCPayment | null; compact?: boolean }) {
  if (!payment || !(payment.refundedAmount > 0 || payment.returnedAmount > 0)) return null;
  const details = payment.returnDetails;
  if (!details) return <small>Детали возврата ещё не получены из 1С</small>;
  const body = <><p>{details.goods}</p><p>{details.handover}</p>{details.timing && <p>{details.timing}</p>}
    <details><summary>Документы возврата ({details.documents.length})</summary>{details.documents.map(doc => <p key={`${doc.kind}:${doc.id}`}><b>{doc.kind === "MoneyRefund" ? "Деньги" : "Товар"}: {doc.number}</b> · {formatDate(doc.date)} · {formatNumber(doc.amount)} {paymentCurrency(payment.currency)}{doc.warehouse && <small>{doc.warehouse}</small>}</p>)}</details></>;
  return compact ? <details className="return-details" onClick={event => event.stopPropagation()}><summary>{details.summary}</summary>{body}</details> : <div className="return-details"><h3>{details.summary}</h3>{body}</div>;
}

export function OrderBalance({ payment }: { payment?: OneCPayment | null }) {
  if (!payment) return null;
  return <><p>К оплате по заказу: <PaymentAmount payment={payment} field="remaining" /></p>{payment.advanceBalance != null && payment.advanceBalance > 0 && <p>Незачтённый аванс: {formatNumber(payment.advanceBalance)} {paymentCurrency(payment.currency)}</p>}{payment.receivableError && <small>{payment.receivableError}</small>}</>;
}
